
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/future-proof-your-hospitality-supply-chain",
      function () {
        return require("private-next-pages/blog/future-proof-your-hospitality-supply-chain.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/future-proof-your-hospitality-supply-chain"])
      });
    }
  